import { useState, type ReactNode } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/16/solid';

type ConsoleCollapsibleCardProps = {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  summary?: string;
};

export default function ConsoleCollapsibleCard({
  title,
  children,
  defaultOpen = false,
  summary,
}: ConsoleCollapsibleCardProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="min-w-0 rounded-xl border border-gray-200 bg-white overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen(prev => !prev)}
        className="flex w-full items-center gap-2 px-3 py-2.5 text-left text-sm font-semibold text-gray-800 bg-gray-50 hover:bg-gray-100"
        aria-expanded={open}
      >
        {open ? (
          <ChevronDownIcon className="h-4 w-4 flex-shrink-0 text-gray-500" />
        ) : (
          <ChevronRightIcon className="h-4 w-4 flex-shrink-0 text-gray-500" />
        )}
        <span className="truncate">{title}</span>
        {!open && summary && (
          <span className="ml-auto truncate text-xs font-normal text-gray-500">{summary}</span>
        )}
      </button>
      {open && <div className="border-t border-gray-100 p-3">{children}</div>}
    </div>
  );
}
